// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_fileItem__CTHyn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 4px;
  background-color: #f5f5f5;
  z-index: 2;
}

.styles_removeFile__GqKkE {
  cursor: pointer;
  color: red;
  font-size: 20px;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/FileUpload/UploadedFile/styles.module.scss"],"names":[],"mappings":"AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAVF;;AAaA;EACE,eAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAVF","sourcesContent":["// .uploadedFiles {\n//     position: absolute;\n//     top: 10px;\n//     left: 10px;\n//     width: calc(100% - 20px);\n//     height: calc(100% - 20px);\n//     display: flex;\n//     flex-direction: column;\n//     overflow-y: auto;\n//   }\n\n.fileItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding: 5px;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  z-index: 2;\n}\n\n.removeFile {\n  cursor: pointer;\n  color: red;\n  font-size: 20px;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileItem": `styles_fileItem__CTHyn`,
	"removeFile": `styles_removeFile__GqKkE`
};
export default ___CSS_LOADER_EXPORT___;
